import { o as o_util } from "../chunks/common-namespaces-client-DhfOpdyM.mjs";
import { o as otto } from "../chunks/common-nexus-client-CdICzBNm.mjs";
const navigationSync = o_util.navigation ?? {};
const paramsMap = navigationSync.paramsMap;
const stateMap = navigationSync.stateMap;
const navigation = otto.navigation ?? {};
const scope = navigation.scope;
const current = navigation.current;
const currentHash = navigation.currentHash;
const currentSearch = navigation.currentSearch;
const currentState = navigation.currentState;
const currentUrl = navigation.currentUrl;
const hashParams = navigation.hashParams;
const searchParams = navigation.searchParams;
export {
  current,
  currentHash,
  currentSearch,
  currentState,
  currentUrl,
  hashParams,
  navigation,
  navigationSync,
  paramsMap,
  scope,
  searchParams,
  stateMap
};
/*                                          */
